import { render, staticRenderFns } from "./PlanBatchesButton.vue?vue&type=template&id=37475cee&scoped=true"
import script from "./PlanBatchesButton.vue?vue&type=script&lang=js"
export * from "./PlanBatchesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37475cee",
  null
  
)

export default component.exports